/** 经营总览（结果） */
export const SECTION_ORDER_ANALYSIS = 'statistics-section-order-analysis';
/** 制作图表 */
export const SECTION_CHART_BUILDER = 'statistics-section-report-builder';
/** 自定义图表库（原经营看板网格） */
export const SECTION_STATISTICS_DASHBOARD = 'statistics-section-dashboard';
